import { useState } from "react";

export function createFormSecurityState() {
    return {
        _hp: "",
        _form_started_at: Date.now(),
    };
}

export function withFormSecurity(payload, security) {
    return {
        ...payload,
        _hp: security._hp ?? "",
        _form_started_at: security._form_started_at ?? Date.now(),
    };
}

export function useFormSecurity() {
    const [security, setSecurity] = useState(createFormSecurityState);

    function resetSecurity() {
        setSecurity(createFormSecurityState());
    }

    return { security, setSecurity, resetSecurity };
}

export function HoneypotField({ value, onChange }) {
    return (
        <div
            aria-hidden="true"
            className="absolute -left-[9999px] top-auto h-0 w-0 overflow-hidden opacity-0 pointer-events-none"
        >
            <label htmlFor="website_confirm">Company website</label>
            <input
                id="website_confirm"
                name="website_confirm"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );
}
